var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("div", { staticClass: "page background-style" }, [
    _c("div", { staticClass: "background-image-style" }),
    _vm._v(" "),
    _c("div", { staticClass: "landing-title" }, [
      _vm._v(
        "\n        " +
          _vm._s(_vm.$t("components.navigation_bar.title_esign")) +
          "\n    "
      ),
    ]),
    _vm._v(" "),
    _c(
      "div",
      { staticClass: "landing-options" },
      [
        _vm.$store.getters.isInRoleArr(
          "ADMIN,R_ESIGN_ADMIN,View_ESignArea/ESign/Index"
        )
          ? _c(
              "router-link",
              { staticClass: "option", attrs: { to: "/ESign", tag: "a" } },
              [
                _c("div", { staticClass: "img-icon-wrapper" }, [
                  _c("img", {
                    staticClass: "img-icon",
                    attrs: { src: "/static/image/ESignJLL.svg" },
                  }),
                ]),
                _vm._v(" "),
                _c("div", { staticClass: "option-text" }, [
                  _vm._v(
                    "\n                " +
                      _vm._s(
                        _vm.$t("components.navigation_bar.title_esign_JLL")
                      ) +
                      "\n            "
                  ),
                ]),
              ]
            )
          : _vm._e(),
        _vm._v(" "),
        _c("v-divider", {
          staticClass: "menu-divider",
          attrs: { vertical: "", color: "white" },
        }),
        _vm._v(" "),
        _vm.$store.getters.isInRoleArr(
          "ADMIN,R_TETRIS_ESIGN_ADMIN,View_TetrisESignArea/TetrisESign/Index"
        )
          ? _c(
              "router-link",
              {
                staticClass: "option",
                attrs: { to: "/ESignTetris", tag: "a" },
              },
              [
                _c("div", { staticClass: "img-icon-wrapper" }, [
                  _c("img", {
                    staticClass: "img-icon",
                    attrs: { src: "/static/image/ESignTetris.svg" },
                  }),
                ]),
                _vm._v(" "),
                _c("div", { staticClass: "option-text" }, [
                  _vm._v(
                    "\n                " +
                      _vm._s(
                        _vm.$t("components.navigation_bar.title_esign_TETRIS")
                      ) +
                      "\n            "
                  ),
                ]),
              ]
            )
          : _vm._e(),
        _vm._v(" "),
        _c("v-divider", {
          staticClass: "menu-divider",
          attrs: { vertical: "", color: "white" },
        }),
        _vm._v(" "),
        _vm.$store.getters.isInRoleArr(
          "DASHBOARD_OVERVIEW,DASHBOARD_JLL,DASHBOARD_TETRIS"
        )
          ? _c(
              "router-link",
              {
                staticClass: "option",
                attrs: { to: "/ESignDashboard", tag: "a" },
              },
              [
                _c("div", { staticClass: "img-icon-wrapper" }, [
                  _c("img", {
                    staticClass: "img-icon",
                    attrs: { src: "/static/image/Dashboard.svg" },
                  }),
                ]),
                _vm._v(" "),
                _c("div", { staticClass: "option-text" }, [
                  _vm._v(
                    "\n                " +
                      _vm._s(
                        _vm.$t(
                          "components.navigation_bar.title_esign_dashboard"
                        )
                      ) +
                      "\n            "
                  ),
                ]),
              ]
            )
          : _vm._e(),
        _vm._v(" "),
        _c("v-divider", {
          staticClass: "menu-divider",
          attrs: { vertical: "", color: "white" },
        }),
        _vm._v(" "),
        _vm.$store.getters.isInRoleArr("JLLT_VIEW")
          ? _c(
              "router-link",
              { staticClass: "option", attrs: { to: "/ESignJLLT", tag: "a" } },
              [
                _c("div", { staticClass: "img-icon-wrapper" }, [
                  _c("img", {
                    staticClass: "img-icon",
                    attrs: { src: "/static/image/JLLT.svg" },
                  }),
                ]),
                _vm._v(" "),
                _c("div", { staticClass: "option-text" }, [
                  _vm._v(
                    "\n                " +
                      _vm._s(
                        _vm.$t("components.navigation_bar.title_esign_JLLT")
                      ) +
                      "\n            "
                  ),
                ]),
              ]
            )
          : _vm._e(),
        _vm._v(" "),
        _c("v-divider", {
          staticClass: "menu-divider",
          attrs: { vertical: "", color: "white" },
        }),
        _vm._v(" "),
        _vm.$store.getters.isInRoleArr("ADMIN, HR_ADMIN")
          ? _c(
              "router-link",
              { staticClass: "option", attrs: { to: "/ESignHR", tag: "a" } },
              [
                _c("div", { staticClass: "img-icon-wrapper" }, [
                  _c("img", {
                    staticClass: "img-icon",
                    attrs: { src: "/static/image/ESignHR.svg" },
                  }),
                ]),
                _vm._v(" "),
                _c("div", { staticClass: "option-text" }, [
                  _vm._v(
                    "\n                " +
                      _vm._s(
                        _vm.$t("components.navigation_bar.title_esign_HR")
                      ) +
                      "\n            "
                  ),
                ]),
              ]
            )
          : _vm._e(),
      ],
      1
    ),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }